module.exports = __webpack_public_path__ + "img/m6.fdd44072.jpg";